module.exports = __webpack_public_path__ + "img/image53.099f1bf0.png";